'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.17.1@axios/lib/cancel/isCancel.js
// module id = eoZI
// module chunks = 0